<template>
	<div class="job--edit--languages-item">
		<h3>
			<span>{{ item.item.label }} (Mindestvoraussetzung)</span>
			<span>
				<a href="#" @click.prevent="$emit('remove')">
					<Icon icon="bin"/>
				</a>
			</span>
		</h3>
		<b-row>
			<b-col
				v-for="specificityTypeAllocation in specificityTypes"
				:key="specificityTypeAllocation.specificityType.id"
			>
				<FormGroup
					:label="specificityTypeAllocation.specificityType.label"
					class="mt-2"
				>
					<Select
						:value="getValue(specificityTypeAllocation)"
						:options="getOptions(specificityTypeAllocation)"
						@input="setValue(specificityTypeAllocation, $event)"
					/>
				</FormGroup>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import Dropdown from "@/vue/characteristic/Dropdown";
import FormGroup from "@/vue/common/form/Group";
import Icon from "@/vue/icon/Icon";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import Select from "../../../../common/form/Select.vue";
import _ from "lodash";
import {LANGUAGE_MOTHER} from "@/helper/job-profile/SpecificityType";
import {NATURAL_ID__NONE} from "@/helper/characteristic/specificity/Specificity";

export default {
	components: {
		Select,
		RadioGroup,
		Icon,
		Dropdown,
		FormGroup,
	},

	props: {
		item: {
			type: Object,
			required: true,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	computed: {
		specificityTypes ()
		{
			return this.meta.languageType.specificityTypes.filter(alloc => alloc.specificityType.id !== LANGUAGE_MOTHER);
		},
		valid ()
		{
			return _.values(this.specificities).length === this.specificityTypes.length;
		}
	},

	data ()
	{
		const specificities = this.item.specificities || [];

		return {
			specificities
		};
	},

	methods: {
		getSpecificityItem (specificityTypeAllocation)
		{
			return _.find(
				this.specificities,
				item => item.specificityType.id === specificityTypeAllocation.specificityType.id
			);
		},
		getValue (specificityTypeAllocation)
		{
			const item = this.getSpecificityItem(specificityTypeAllocation);

			return item?.specificity;
		},
		setValue (specificityTypeAllocation, value)
		{
			const item = this.getSpecificityItem(specificityTypeAllocation);

			if (!item)
			{
				this.specificities.push({
					specificityType: specificityTypeAllocation.specificityType,
					specificity: value,
				});
			}
			else
			{
				this.$set(item, 'specificity', value);
			}

			this.emitChangeEvent();
		},
		getOptions (specificityTypeAllocation)
		{
			return _.map(
				specificityTypeAllocation.specificityType.allocations,
				allocation =>
				{
					return {
						value: allocation.specificity,
						text: allocation.specificity.naturalId === NATURAL_ID__NONE
							? 'Wünschenswert, aber nicht Voraussetzung'
							: allocation.specificity.label
					};
				}
			);
		},
		emitChangeEvent ()
		{
			let specificities = _.cloneDeep(this.specificities);

			this.$emit('input', {
				specificities,
				valid: this.valid
			});
		}
	}
}
</script>
